"use strict";

import $ from 'jquery';
import _ from 'underscore';

import Immutable from 'immutable';
import Fluxxor from 'fluxxor';

import moment from 'ofs/moment';
import Constants from 'ofs/apps/core/constants';


var AvailabilityStore = Fluxxor.createStore({
  actions: {
    HIGHLIGHT_CALENDAR_DATE: 'onHighlightDate',
    HIGHLIGHT_CALENDAR_RANGE: 'onHighlightRange',
    UNHIGHLIGHT_CALENDAR_DATE: 'onUnHighlightDate',
    START_CALENDAR_RANGE_SELECTION: 'onStartRangeSelection',
    COMPLETE_CALENDAR_RANGE_SELECTION: 'onCompleteRangeSelection'
  },

  initialize(options) {
    var stateRanges;

    this.setMaxListeners(0);
    this.state = Immutable.fromJS(options);

    stateRanges = this.state.get('stateRanges').map(r =>
      Immutable.Map({
        range: moment().range(r.get(0), r.get(1)),
        state: r.get(2),
        selectable: r.get(3)
      })
    );

    this.state = this.state.set('stateRanges', stateRanges);
    this.state = this.state.set('selectionType', 'range');

    if (this.state.get('preSelectedStartDate') && this.state.get('preSelectedEndDate')) {
      this.state = this.state.set('selectedRange', moment().range(
        this.state.get('preSelectedStartDate'),
        this.state.get('preSelectedEndDate')
      ));

      this.state = this.state.set(
        'selectedRangeStates',
        this.statesForRange(this.state.get('selectedRange'))
      );
    }
  },

  onStartRangeSelection(payload) {
    this.state = this.state.set('selectedStartDate', payload.date);
    this.emit('change');
  },

  onCompleteRangeSelection(payload) {
    this.state = this.state.withMutations(function(s) {
      s
        .set('selectedRange', payload.range)
        .set('selectedRangeStates', Immutable.fromJS(payload.states))
        .set('selectedStartDate',  null)
        .set('highlightedRange',  null)
        .set('highlightedDate', null);
    });
    this.emit('change');
  },

  statesForRange(range) {
    if (range.start.isSame(range.end)) {
      return this.state.get('stateRanges').filter(d => range.start.within(d.get('range'))).map(d => d.get('state'));
    }
    return this.state.get('stateRanges').filter(d => d.get('range').intersect(range)).map(d => d.get('state'));
  },

  onHighlightDate(payload) {
    this.state = this.state.set('highlightedDate', payload.date);
    this.emit('change');
  },

  onHighlightRange(payload) {
    this.state = this.state.withMutations(function(s) {
      s
        .set('highlightedRange', payload.range)
        .set('highlightedDate', null);
    });
    this.emit('change');
  },

  onUnHighlightDate(payload) {
    this.state = this.state.set('highlightedDate', null);
    this.emit('change');
  }
});

export default AvailabilityStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/stores/AvailabilityStore.js
 **/